export default __webpack_public_path__ + "static/media/download.263e2910.svg";